<template>
    <div class="navbar-mobile" v-show="!hideMobileNav">
        <nav class="navbar-mobile__nav">
            <DynamicLink
                v-for="(link, index) in navLinks"
                @click="analytics.sendPageCategoryNavigation(link.name, 'kurzovesazky.bottomMenu')"
                :key="index"
                :path="link.path"
                class="navbar-mobile__link"
                :class="{ 'navbar-mobile__link--active': isActive(link.path) }"
            >
                <Badge
                    v-if="link.path === PATHS.TICKET && ticketCount > 0"
                    class="navbar-mobile__badge"
                    :value="ticketCount"
                />
                <SvgIcon v-show="isActive(link.path)" :name="`${link.icon}-fill`" :size="24" />
                <SvgIcon v-show="!isActive(link.path)" :name="link.icon" :size="24" />
                <span class="button-text">{{ link.name }}</span>
            </DynamicLink>
            <DynamicLink @click="handleSearchClick" :path="PATHS.SEARCH" class="navbar-mobile__link">
                <SvgIcon name="search" :size="24" />
                <span class="button-text">Hledání</span>
            </DynamicLink>
        </nav>
        <PanicButton />
    </div>
</template>

<script setup lang="ts">
import SvgIcon from "@/shared/components/atoms/SvgIcon.vue";
import { PATHS } from "@/router/paths";
import { useRoute, useRouter } from "vue-router";
import PanicButton from "@/shared/components/molecules/PanicButton.vue";
import { useTicketStore } from "@/ticket/stores/use-ticket-store";
import { computed } from "vue";
import Badge from "primevue/badge";
import { useSearchStore } from "@/shared/stores/use-search-store";
import analytics from "@/shared/analytics";
import DynamicLink from "@/shared/components/atoms/DynamicLink.vue";

const route = useRoute();
const router = useRouter();
const ticketStore = useTicketStore();
const searchStore = useSearchStore();

const navLinks = [
    {
        icon: "home",
        name: "Domů",
        path: PATHS.HOME,
    },
    {
        icon: "time",
        name: "Live",
        path: PATHS.LIVE,
    },
    {
        icon: "ticket",
        name: "Tiket",
        path: PATHS.TICKET,
    },
    {
        icon: "cup",
        name: "Sporty",
        path: PATHS.PREMATCH,
    },
];

const hideMobileNav = computed(() => route.path === PATHS.SEARCH);

const isActive = (path: string) => {
    return route.path.split("/")?.[1] === router.resolve(path).href.split("/")?.[2];
};

const ticketCount = computed(() => ticketStore.ticketOutcomeCount || 0);

const handleSearchClick = () => {
    analytics.sendPageCategoryNavigation("Hledání", "kurzovesazky.bottomMenu");
    searchStore.openedSearchPosition = "footer.all";
};
</script>
